import type { Skill } from "./types";

export function skillsToCsv(skills: Skill[]): string {
  const headers = [
    "name",
    "category",
    "combined%",
    "structural%",
    "tier",
    "status",
    "lines",
    "broken_refs",
    "issues",
    "fix_priority",
    "path",
    "github",
  ];
  const rows = skills.map((s) => [
    s.name,
    s.category,
    String(s.combinedPercentage),
    String(s.structuralPercentage),
    s.tier,
    s.status,
    String(s.lineCount),
    String(s.brokenRefs.length),
    String(s.issues.length),
    String(s.fixPriority ?? ""),
    s.path,
    s.githubUrl ?? "",
  ]);
  const esc = (v: string) => (/[",\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v);
  return [headers.join(","), ...rows.map((r) => r.map(esc).join(","))].join("\n");
}

export function skillsToJson(skills: Skill[]): string {
  return JSON.stringify(
    skills.map((s) => ({
      name: s.name,
      category: s.category,
      combinedPercentage: s.combinedPercentage,
      structuralPercentage: s.structuralPercentage,
      llmPercentage: s.llmPercentage,
      tier: s.tier,
      status: s.status,
      lineCount: s.lineCount,
      brokenRefs: s.brokenRefs,
      issueCount: s.issues.length,
      fixPriority: s.fixPriority,
      path: s.path,
    })),
    null,
    2
  );
}

export function downloadFile(filename: string, content: string, mime: string) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadCsv(filename: string, content: string) {
  downloadFile(filename, content, "text/csv;charset=utf-8");
}

export function downloadJson(filename: string, content: string) {
  downloadFile(filename, content, "application/json;charset=utf-8");
}

export function exportSkillsCsv(skills: Skill[]) {
  downloadCsv(`skills-export-${Date.now()}.csv`, skillsToCsv(skills));
}

export function exportSkillsJson(skills: Skill[]) {
  downloadJson(`skills-export-${Date.now()}.json`, skillsToJson(skills));
}